import { Navigate } from "react-router-dom";
import AddRole from "./AddRole";

const RoleList = (props) => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }
  return (
    <div className="add-role-page-wrapper">
      <AddRole />
    </div>
  );
};

export default RoleList;
